var map = {
	"./logo-greater_good.png": 232,
	"./logo-inc.png": 233,
	"./logo-ted.png": 234,
	"./thumb-inc.png": 235,
	"./thumb-ted.png": 236
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 556;


//////////////////
// WEBPACK FOOTER
// ./src/imgs/articles ^\.\/.*\.png$
// module id = 556
// module chunks = 0